import { useI18n } from '@react/i18n';
import { Spinner } from './ui';

interface Props {
    backUrl: string;
    submitting: boolean;
    disabled: boolean;
}

/** Odeslání objednávky + návrat na předchozí krok. */
export default function SubmitBar({ backUrl, submitting, disabled }: Props) {
    const t = useI18n();
    return (
        <fieldset className="basket-move basket-move--step-3 clearfix">
            <p className="clearfix basket-move__right no-padding--left--md no-padding--left--lg">
                <button type="submit" className="btn btn--custom-1 btn--basket" disabled={disabled}>
                    {submitting && <Spinner className="rc-btn-spinner" />}
                    <span>{submitting ? t('Odesílám...') : t('Order with obligation to pay')}</span>
                </button>
            </p>
            <p className="clearfix basket-move__left">
                <a className="btn btn-default btn-sm" href={backUrl}>{t('← Zpět')}</a>
            </p>
        </fieldset>
    );
}
